// extracted by mini-css-extract-plugin
export default {"uplifts":"Uplifts_uplifts__a2+bi","uplifts__title":"Uplifts_uplifts__title__XbuPY","uplifts__img":"Uplifts_uplifts__img__yzQFx"};